<div class="fz-filter-panel__header">
  <div class="mat-title-large">Filters</div>
  <button mat-button (click)="clear.emit()">Clear all</button>
</div>
@if (countUserSelections() > 0) {
  <div class="fz-filter-panel__resume">
    <div class="fz-filter-section">
      <div class="fz-filter-section__header">
        <h4
          class="fz-filter-section__header__title mat-title-small font-color--tertiary"
        >
          Your selections ({{ countUserSelections() }})
        </h4>
      </div>
      <div class="fz-filter-section__content">
        <fz-current-refinements
          [facet]="facet()"
          [filters]="filters()"
          (removeItem)="removeSelection($event)"
        ></fz-current-refinements>
      </div>
    </div>
  </div>
}
<div class="fz-filter-panel__content">
  @for (group of items(); track group.key; let last = $last) {
    <fz-filter-section
      [key]="group.key"
      [title]="group.label"
      [items]="group.items"
      [filters]="filters()"
      (selection)="selectionChange($event)"
    >
    </fz-filter-section>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  }
</div>
